import { render, staticRenderFns } from "./UseCase4.vue?vue&type=template&id=59f28ea4&scoped=true&"
import script from "./UseCase4.vue?vue&type=script&lang=js&"
export * from "./UseCase4.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59f28ea4",
  null
  
)

export default component.exports